import React from 'react';

import { FormattedMessage } from 'react-intl';

import Lozenge, { type SemanticColor } from '@atlaskit/lozenge';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { CalendarXSIcon } from '../../ui/calendar-xs-icon';

import { messages } from './messages';

interface StatusTargetDateDisplayProps {
	displayedStatus: string;
	displayedStatusAppearance: SemanticColor;
	displayedTargetDate?: React.JSX.Element;
}

export const StatusTargetDateDisplay: ({
	displayedStatus,
	displayedStatusAppearance,
	displayedTargetDate,
}: StatusTargetDateDisplayProps) => React.JSX.Element = ({
	displayedStatus,
	displayedStatusAppearance,
	displayedTargetDate,
}: StatusTargetDateDisplayProps) => {
	return (
		<Box xcss={statusAndTargetDateXcss} testId="search-status-target-date-display">
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */}
			<Lozenge appearance={displayedStatusAppearance}>{displayedStatus}</Lozenge>
			{displayedTargetDate && (
				<>
					{' '}
					<Box xcss={targetDateForXcss}>
						<FormattedMessage {...messages.for} />
					</Box>
					<Lozenge>
						<Inline alignBlock="center" space="space.050">
							<CalendarXSIcon /> {displayedTargetDate}
						</Inline>
					</Lozenge>
				</>
			)}
		</Box>
	);
};

const statusAndTargetDateXcss = xcss({
	display: 'flex',
	alignItems: 'center',
	gap: 'space.100',
	// Fix height to match text lineHeight so that inline
	// children with built-in margins (e.g. Tag) do not cause the row to grow taller.
	height: token('space.200'),
});
const targetDateForXcss = xcss({ font: token('font.body.small'), color: 'color.text.subtlest' });
